import React, { memo } from 'react';
import { string, array, object, bool } from 'prop-types';
import { getFormattedDurationTime } from '../../../../../../../helpers/utils';
import * as Styled from '../Style';
const DefaultMobileLayout = ({
  timeInRoad,
  segment,
  criticalInfo,
  isCheckout
}) => /*#__PURE__*/React.createElement(Styled.DetailsRouteInfo, {
  isMobile: true
}, !isCheckout && /*#__PURE__*/React.createElement(Styled.Title, null, I18n.t('pages.search.trip.tabs.title.route')), timeInRoad && /*#__PURE__*/React.createElement(Styled.DetailsTimeInRoad, null, I18n.t('pages.search.trip.tabs.route.table.time_in_road_title'), ":", ' ', getFormattedDurationTime(timeInRoad, 1)), /*#__PURE__*/React.createElement(Styled.LocalTimeInfo, null, I18n.t('components.Order.local_time')), segment, criticalInfo);
DefaultMobileLayout.propTypes = {
  timeInRoad: string,
  segment: array,
  criticalInfo: object,
  isCheckout: bool
};
export default /*#__PURE__*/memo(DefaultMobileLayout);